import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeContractOtherSalary  {
    _originalTypeClassName = "zERP.BO.EmployeeContractOtherSalary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeContractOtherSalary.translate = translateService;
}
this.Id = null;
this.ParameterValue = null;
this.DateFrom = null;
this.DateTo = null;
this.Disable = false;
this.OverrideTemplate = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ParameterValue:any;
DateFrom:any;
DateTo:any;
Disable:any;
OverrideTemplate:any;
Rule:any;
static setRule = ($this, value) => {
var oldValue = $this.Rule;
$this.Rule = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}